import { useState, useEffect } from "react";
import { installationService } from "services";
import { IInstallations } from "config/interfaces";

interface SelectOptions {
  label: string;
  value: string | number;
  description: string;
}

const dataToTest: Array<IInstallations.Table> = [
  {
    codigo: "AAA-A65A60",
    bairro: "MORRO DO ALGODAO",
    cidade: "CARAGUATATUBA",
    estado: "SP",
    local: "SHOPPING SERRAMAR",
    logradouro: "AV. CASTELO BRANCO, 203",
    status: "ATIVO",
  },
  {
    codigo: "BBB-A65A60",
    bairro: "TRAVESSAO",
    cidade: "CARAGUATATUBA",
    estado: "SP",
    local: "SHOPPING CENTER PRAIA",
    logradouro: "AV. JOAO SIQUEIRA, 400",
    status: "ATIVO",
  },
  {
    codigo: "CCC-A65A60",
    bairro: "JARAGUA",
    cidade: "CARAGUATATUBA",
    estado: "SP",
    local: "HIPERMERCADO ATACADAO",
    logradouro: "AV. GUILHERME DE ALMEIRA, 200",
    status: "ATIVO",
  },
];

export default function useSet(installationId?: string) {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [installations, setInstallations] = useState(
    [] as IInstallations.Table[]
  );
  const [autocompleteOptions, setAutocompleteOptions] = useState<any[]>([]);
  const [installationsShort, setInstallationsShort] = useState(
    [] as IInstallations.Installation[]
  );
  const [installationsSelectOptions, setInstallationsSelectOptions] = useState(
    [] as Array<SelectOptions>
  );

  useEffect(() => {
    // setAddreesses(data);
    setLoading(true);
    if (!installationId) {
      (async () => {
        try {
          const { data } = await installationService.getAllShort();
          setInstallationsShort(data);

          const options = data.map((installation) => {
            return {
              description: installation.DSINSTALL,
              label: installation.IDSITE,
              value: installation.IDSITE,
            };
          });
          const autoC = data.map((installation) => {
            return {
              label: `${installation.DSINSTALL} (${installation.IDSITE})`,
              value: installation.IDSITE,
            };
          });
          setAutocompleteOptions(autoC);
          setInstallationsSelectOptions(options);
        } catch (error: any) {
          setErrorMessage(error?.response?.data?.message);
        } finally {
          setLoading(false);
        }
      })();
    } else {
      // (async () => {
      //   try {
      //     const { data } = await addreessesService.getAll({ OFFSET: 0, LIMIT: 20, IDTRANSACAO: Number(orderId) });
      //     setAddreesses(data);
      //     setLoading(false);
      //   } catch (error) {
      //     setErrorMessage(error?.response?.data?.message);
      //   } finally {
      //     setLoading(false);
      //   }
      // })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAllInstallations = async () => {
    setLoading(true);
    try {
      // const { data } = installationService.getAllShort();
      setInstallations(dataToTest);
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    errorMessage,
    error,
    setError,
    installationsShort,
    success,
    setSuccess,
    installationsSelectOptions,
    installations,
    getAllInstallations,
    autocompleteOptions,
  };
}
